import { Loading } from '@vnetwork/datacentral-ui/feedback'

/** Suspense fallback while a lazily loaded page chunk downloads. */
const PageFallback = () => (
    <div className="flex min-h-64 items-center justify-center">
        <Loading />
    </div>
)

export default PageFallback
